import {isMoment} from "libs/moment";

export default (potentiallyValidMomentObject, defaultValue) => {
    return isMoment(potentiallyValidMomentObject) ? (potentiallyValidMomentObject.isValid() ? potentiallyValidMomentObject : defaultValue) : defaultValue
}